import ChartCompareSetSelectContext from "components/charting/contexts/ChartCompareSetSelectContext";
import ChartSetSelectContext from "components/charting/contexts/ChartSetSelectContext";
import ProfilingComparisonContext from "components/charting/contexts/ProfilingComparisonContext";
import { ProfilingChartEntityId } from "components/charting/types";
import useDefinedContext from "hooks/useDefinedContext";
import ChartColorRegistryProvider from "features/Charting/providers/ChartColorRegistryProvider";
import { useMemo } from "react";

interface AthleteProfilingChartEntityColorProviderProps {
  children?: React.ReactNode;
}

function AthleteProfilingChartEntityColorProvider(props: AthleteProfilingChartEntityColorProviderProps) {
  const { value: selectedSets } = useDefinedContext(ChartSetSelectContext);
  const { value: selectedCompareSets } = useDefinedContext(ChartCompareSetSelectContext);

  const isComparison = Boolean(selectedSets.length && selectedCompareSets.length);

  const entityIds = useMemo(
    () =>
      ([] as string[])
        .concat(ProfilingChartEntityId.PROFILING_LINE, ProfilingChartEntityId.COMPARATIVE_LINE)
        .concat(...selectedSets.map((v) => v.measurementId))
        .concat(...selectedCompareSets.map((v) => v.measurementId)),
    [selectedCompareSets, selectedSets]
  );

  return (
    <ProfilingComparisonContext.Provider value={isComparison}>
      <ChartColorRegistryProvider entityIds={entityIds}>{props.children}</ChartColorRegistryProvider>
    </ProfilingComparisonContext.Provider>
  );
}

export default AthleteProfilingChartEntityColorProvider;
